<template>
  <div>
    <h2>Our Apps</h2>
    <div class="apps-section">
      <AppCard
          v-for="app in apps"
          :key="app.name"
          :name="app.name"
          :thumbnail="app.thumbnail"
          :description="app.description"
          :status="app.status"
      />
    </div>

    <h2>Meet the Team</h2>
    <div class="team-section">
      <TeamMember
          v-for="member in teamMembers"
          :key="member.name"
          :memberName="member.name"
          :thumbnail="member.thumbnail"
          :description="member.description"
          :hasView="member.hasView"
      />
    </div>
  </div>
</template>

<script>

import AppCard from '../components/AppCard.vue';
import TeamMember from '../components/TeamMember.vue';

export default {
  components: {AppCard, TeamMember},
  data() {
    return {
      apps: [

        {
          name: 'Construction Code AI Assistant',
          thumbnail: require('@/assets/CAv2.png'),
          description: 'Brings the power of trained & targeted AI to the building industry',
          status: '',
        },

/*
        {
          name: 'Come At Me',
          thumbnail: require('@/assets/camb.png'),
          description: 'A social challenge platform designed to connect and compete',
          status: 'Coming Soon!',
        },
*/

      ],
      teamMembers: [
        {
          name: 'Ryan',
          thumbnail: require('@/assets/ryan.png'),
          description: 'Co-founder, visionary, and tech wizard behind Unemployed Deadbeats.',
          hasView: false,
        },
        {
          name: 'Jim',
          thumbnail: require('@/assets/jim.png'),
          description: 'Co-founder, creative strategist, and problem solver extraordinaire.',
          hasView: true,
        },
      ],
    };
  },
};

</script>